export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_AWS_USER_POOLS_ID ?? '',
      userPoolClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID ?? '',
      identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID ?? '',
      loginWith: { phone: true },
      passwordFormat: { minLength: 6 },
    },
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET ?? '',
      region: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET_REGION ?? '',
    },
  },
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT ?? '',
      region: process.env.REACT_APP_AWS_PROJECT_REGION ?? '',
      defaultAuthMode: 'userPool' as const,
    },
  },
};

export const launchDarklyConfig = {
  clientSideID: process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID || "",
};
